export default __webpack_public_path__ + "static/media/muralpaint.cfe81b7b.mp4";